/* eslint-disable */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueAxios from 'vue-axios'
import axios from 'axios'

import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import Vue3EasyDataTable from 'vue3-easy-data-table'
import 'vue3-easy-data-table/dist/style.css'
import { LoadingPlugin } from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/css/index.css'
import VueGoogleMaps from '@fawmi/vue-google-maps'
import BootstrapVue3 from 'bootstrap-vue-3'

import CoreuiVue from '@coreui/vue'
import CIcon from '@coreui/icons-vue'
import { iconsSet as icons } from '@/assets/icons'
import './registerServiceWorker'

library.add(fas, far, fab)
dom.watch()

const app = createApp(App)
app.use(store)
app.use(router)
app.use(CoreuiVue)
app.use(BootstrapVue3)
app.use(VueAxios, axios)
app.provide('icons', icons)
app.component('EasyDataTable', Vue3EasyDataTable)
app.component('CIcon', CIcon)
app.component('font-awesome-icon', FontAwesomeIcon)
app.component('Datepicker', Datepicker)
app.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCqyuq_jSqUcZHCjP1yBJluVnUHAVkL_lo',
    libraries: 'places' // necessary for places input
  }
})

app.use(
  LoadingPlugin,
  {
    width: 65,
    height: 65,
    backgroundColor: 'black',
    opacity: 0.5,
    loader: 'dots',
    color: 'black'
  },
  {}
)

fetch('config.json')
  .then((res) => res.json())
  .then((config) => {
    const instance = axios.create({
      // withCredentials: true,
      baseURL: config.baseURL
    })
    app.config.globalProperties.$url = instance
    app.config.globalProperties.$announcementRssURL = config.announcementRssURL
    app.mount('#app')
  })
